import BaseController from '../base_controller'

// Main SNP calculator controller: orchestrates lifecycle (after calculate, vessel added/removed,
// assumptions changed) so js.haml only dispatches events and this controller runs the steps.
export default class extends BaseController {
  static targets = ['vesselForm', 'customLabelLineBreaker', 'customMvResultCell', 'formsWrapper', 'addVesselWrapper']

  connect() {
    this.element.addEventListener('snp:afterCalculate', (e) => this.afterCalculate(e.detail))
    this.element.addEventListener('snp:vesselAdded', (e) => this.vesselAdded(e.detail))
    this.element.addEventListener('snp:vesselRemoved', (e) => this.afterVesselRemoved(e.detail))
  }

  afterCalculate(detail) {
    if (!detail?.imo) return
    this.dispatch('syncCollapseStyles')
    if (typeof startTooltips === 'function') startTooltips()
    this.highlightCustomResult()
    const formEl = this.vesselFormTargets.find(el => el.dataset.imo === detail.imo)
    if (typeof startMarketValueModal === 'function') startMarketValueModal(formEl)
    if (typeof startGaugePointer === 'function') startGaugePointer()
    if (typeof initCalcCharts === 'function') initCalcCharts(window.$ ? window.$(formEl) : null)
    if (typeof clearFormFeedback === 'function') clearFormFeedback()
    if (formEl) formEl.querySelectorAll('.calc-cell input').forEach((i) => i.classList.remove('double-border'))
  }

  vesselAdded(detail) {
    const { vesselHtml, imo, assumptionDate } = detail
    if (!this.hasFormsWrapperTarget) return
    if (this.hasAddVesselWrapperTarget) {
      this.addVesselWrapperTarget.insertAdjacentHTML('beforebegin', vesselHtml)
    } else {
      this.formsWrapperTarget.insertAdjacentHTML('beforeend', vesselHtml)
    }
    if (assumptionDate) {
      const newForm = this.vesselFormTargets.find(el => el.dataset.imo === imo)
      if (newForm) this.dispatch('assumptionDateChanged', { target: newForm, detail: { date: assumptionDate } })
    }
    this.afterVesselAdded({ assumptionDate })
  }

  afterVesselAdded(detail) {
    this.dispatch('syncCollapseStyles')
    if (detail?.assumptionDate && typeof dispatchFutureVesselCheck === 'function') dispatchFutureVesselCheck(detail.assumptionDate)
    if (typeof dispatchSyncCustomSectionVisibility === 'function') dispatchSyncCustomSectionVisibility()
    if (typeof disabledVesselCheck === 'function') disabledVesselCheck()
    if (typeof dispatchShowSpeedConsToggle === 'function') dispatchShowSpeedConsToggle()
    if (typeof startTooltips === 'function') startTooltips()
  }

  afterAssumptionsChanged(detail) {
    if (detail?.assumptionDate && typeof dispatchFutureVesselCheck === 'function') dispatchFutureVesselCheck(detail.assumptionDate)
    if (typeof disabledVesselCheck === 'function') disabledVesselCheck()
    if (typeof startTooltips === 'function') startTooltips()
  }

  highlightCustomResult() {
    this.vesselFormTargets.forEach(form => this.dispatch('highlightCustomResult', { target: form }))
    this.syncCustomLabelHighlight()
  }

  syncCustomLabelHighlight() {
    const anyHighlighted = this.customMvResultCellTargets.some(el => el.classList.contains('custom-speed-cons'))
    this.customLabelLineBreakerTargets.forEach(el => el.classList.toggle('custom-speed-cons', anyHighlighted))
  }

  afterVesselRemoved(detail) {
    if (!detail?.imo) return
    const form = this.vesselFormTargets.find(el => el.dataset.imo === detail.imo)
    if (form) {
      bootstrap.Tooltip.getInstance(form)?.dispose()
      form.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
        bootstrap.Tooltip.getInstance(el)?.dispose()
      })
      form.remove()
    }
    this.hideLoading()
    if (typeof dispatchSyncCustomSectionVisibility === 'function') dispatchSyncCustomSectionVisibility()
    if (typeof dispatchShowSpeedConsToggle === 'function') dispatchShowSpeedConsToggle()
  }
}
